const o = {
  name: "ArrowTopSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9998 7.41397L10.9998 19.9999H12.9998L12.9998 7.41427L16.9997 11.4141L18.4139 9.99991L11.9997 3.58569L5.58545 9.9999L6.99966 11.4141L10.9998 7.41397Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowTopSmall
};
